import { render } from "./FolderOpenView.vue?vue&type=template&id=5f7ed6f6&scoped=true"
import script from "./FolderOpenView.vue?vue&type=script&lang=js"
export * from "./FolderOpenView.vue?vue&type=script&lang=js"

import "./FolderOpenView.vue?vue&type=style&index=0&id=5f7ed6f6&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7ed6f6"]])

export default __exports__